import {del, get, post, put} from "../../../../GlobalModules/Utility/Http";
import {
    stockTransferCreatePost, stockTransferDeleteDel,
    stockTransferDetailsGet,
    stockTransferListGet,
    stockTransferUpdatePut
} from "../Model/StockTranferModel";

/**
 * Fetch stock transfer list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed stock transfer list data
 */
export const getStockTransferList = async (filters = {}) => {
    // Format filters according to the API structure in Postman collection
    const queryParams = {
        filters: {
            store_id: localStorage.getItem('store_id'),
            limit: filters.limit || 10,
            offset: filters.offset || 0,
        }
    };

    if (filters.from_created_date) {
        queryParams.filters.from_created_date = filters.from_created_date;
    }

    if (filters.to_created_date) {
        queryParams.filters.to_created_date = filters.to_created_date;
    }

    if (filters.search) {
        queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
        queryParams.filters.search_attr = filters.search
    }

    if (filters.sort) {
        queryParams.filters.sort = filters.sort.map(item => ({
            colId: item.field,
            sort: item.sort
        }));
    }

    queryParams.filters = JSON.stringify(queryParams.filters);

    const response = await get(`${process.env.EXTENDED_URL}/stock_transfer`, queryParams);

    return stockTransferListGet(response)
}

/**
 * Create a new stock transfer
 * @param {Object} stockTransferData - Stock transfer data to create
 * @returns {Promise} Creation response
 */
export const createStockTransfer = async (stockTransferData) => {
    const response = await post(`${process.env.EXTENDED_URL}/stock_transfer`, stockTransferData);
    return stockTransferCreatePost(response);
};

/**
 * Fetch single stock transfer details by ID
 * @param {string|number} id - Stock transfer ID
 * @returns {Promise} Processed stock transfer details
 */
export const getStockTransferDetails = async (id) => {
    const response = await get(`${process.env.EXTENDED_URL}/stock_transfer/${id}`);
    return stockTransferDetailsGet(response);
};

/**
 * Update an existing stock transfer
 * @param {string|number} slack - Stock transfer ID
 * @param {Object} stockTransferData - Updated stock transfer data
 * @returns {Promise} Update response
 */
export const updateStockTransfer = async (slack, stockTransferData) => {
    const response = await put(`${process.env.EXTENDED_URL}/stock_transfer/${slack}`, stockTransferData);
    return stockTransferUpdatePut(response);
};

/**
 * Delete a stock transfer
 * @param {string|number} slack - Stock transfer ID
 * @returns {Promise} Delete response
 */
export const deleteStockTransfer = async (slack) => {
    const response = await del(`${process.env.EXTENDED_URL}/stock_transfer/${slack}`);
    return stockTransferDeleteDel(response);
};